module.exports = __webpack_public_path__ + "static/footer_title-acde63b9814b1d033de46739d400e522.png";